import {
  Component, ViewEncapsulation, Input, ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-selected-filters-cont',
  templateUrl: './selected-filters-cont.component.html',
  styleUrls: ['./selected-filters-cont.component.sass'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SelectedFiltersContComponent {

  @Input() isMobile: boolean;
  @Input() viewSelectedFilters: boolean;
  @Input() inFilterBar: boolean;
  @Input() styles: { [key: string]: string };
  @Input() sticky: boolean;

  constructor() { }

}
